import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import the translation file directly
import translationEN from '../locales/en/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

console.log('🌐 [i18n] Initialized with translation keys:', Object.keys(translationEN).slice(0, 10));

export default i18n;
